export default "__VITE_PUBLIC_ASSET__214c1f54__"